export default __webpack_public_path__ + "static/media/logo-github.08059151.svg";